// extracted by mini-css-extract-plugin
export default {"actionsContainer":"actionsContainer-LUIwioFZ","button":"button-K0Clh_O_","passivelyActive":"passivelyActive-aJSQ4zwo"};